class BaseCommunicator {
    getDeviceType() {
        throw new Error("getConfig is not implemented");
    }

    getConfig() {
        throw new Error("getConfig is not implemented");
    }

    disableFairtiqModal() {
        throw new Error("disableFairtiqModal is not implemented");
    }

    openDeeplink(deeplink, url) {
        throw new Error("openDeeplink is not implemented");
    }

    trackPageImpression(pageName) {
        throw new Error("Not implemented");
    }

    trackEvent(action, category, label) {
        throw new Error("Not implemented");
    }
}

export default BaseCommunicator;
